function GradientBox({ children }) {
    return (
        <div
            style={{
                backgroundImage: "url('/assets/homepage/service/bg.svg')",
                backgroundPosition: 'bottom center',
                backgroundRepeat: 'no-repeat',
            }}
            className="pt-1">
            <div className="py-16 mt-14 md:mt-32 mx-4 px-3 sm:px-12 md:px-24 max-w-7xl my-12 olm-gradient rounded-xl md:rounded-lg md:mx-auto">
                {children}
            </div>
        </div>
    )
}

export default GradientBox
